import * as React from 'react';
import { Theme } from '../../config/aws-exports';
import { Box } from '@mui/system';
import styled from 'styled-components';

export const StyledSecondaryCardGrid = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  height: 150px;
  margin: 1rem 0.5rem;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: ${Theme.boxShadow};

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 335px;

  /* Blur overlay */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    backdrop-filter: blur(2px); /* Less blur */
    background-color: rgba(0, 0, 0, 0.1); /* Lighter overlay */
    z-index: 1;
  }

  .content {
    position: relative;
    z-index: 2;
    padding: 1rem;
    color: white;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;

    p {
      font-size: 1.2rem;
      font-weight: bold;
      margin: 0;
      line-height: 1.4;
      word-break: break-word;
    }
  }
`;

const CardTopicsSecondary = ({ img, handleLocation, title }) => (
  <StyledSecondaryCardGrid
    onClick={handleLocation}
    style={{ backgroundImage: `url(${img})` }}
  >
    <div className='content'>
      <p>{title}</p>
    </div>
  </StyledSecondaryCardGrid>
);

export default CardTopicsSecondary;
